module.exports = __webpack_public_path__ + "static/media/BeingStyled-or-Arrived.e1ecf90d.svg";